/* Paw & Co — interacciones (vanilla, sin librerías) */
(function () {
  if (window.__pcIniciado) return;
  window.__pcIniciado = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Entradas al hacer scroll (un solo observador) ---------- */
  var observador = null;
  var inicioReveal = null;
  // Lo que está en pantalla al cargar (o al restaurar el scroll tras recargar) se muestra sin animar
  function marcarYa(el) { el.classList.add('pc-visible', 'pc-ya'); }
  function enPantalla(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight && r.bottom > 0; }
  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.pc-reveal:not(.pc-visible), [data-pc-observar]:not(.pc-visible)');
    if (!els.length) return;
    if (inicioReveal === null) inicioReveal = performance.now();
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pc-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          if (performance.now() - inicioReveal < 800) marcarYa(e.target);
          else e.target.classList.add('pc-visible');
          observador.unobserve(e.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) {
      if (enPantalla(el) && performance.now() - inicioReveal < 800) marcarYa(el);
      else observador.observe(el);
    });
  }

  /* ---------- Marquesinas: duplica el contenido para el bucle infinito ---------- */
  function initMarquesinas(raiz) {
    (raiz || document).querySelectorAll('[data-pc-bucle]').forEach(function (pista) {
      if (pista.dataset.pcListo) return;
      pista.dataset.pcListo = '1';
      var hijos = Array.prototype.slice.call(pista.children);
      // Asegura que el contenido cubra al menos 2 pantallas antes de duplicar
      var ancho = pista.scrollWidth || 1;
      var veces = Math.max(1, Math.ceil((window.innerWidth * 1.2) / ancho));
      for (var v = 1; v < veces; v++) hijos.forEach(function (h) { pista.appendChild(h.cloneNode(true)); });
      Array.prototype.slice.call(pista.children).forEach(function (h) {
        var c = h.cloneNode(true); c.setAttribute('aria-hidden', 'true'); pista.appendChild(c);
      });
    });
  }

  /* ---------- Parallax suave en imágenes marcadas ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var els = document.querySelectorAll('[data-pc-parallax]');
    if (!els.length) return;
    var pendiente = false;
    function actualiza() {
      pendiente = false;
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var f = parseFloat(el.dataset.pcParallax) || 0;
        var centro = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (centro * f * -1).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(actualiza); } }, { passive: true });
    actualiza();
  }

  /* ---------- Página de producto ---------- */
  function formatoDinero(centimos, formato) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(centimos, formato); } catch (e) {}
    }
    var valor = (centimos / 100).toFixed(2);
    var coma = valor.replace('.', ',');
    var sinDec = Math.round(centimos / 100).toString();
    return (formato || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sinDec)
      .replace(/\{\{\s*amount\s*\}\}/, valor);
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-pc-producto]').forEach(function (wrap) {
      if (wrap.dataset.pcListo) return;
      wrap.dataset.pcListo = '1';
      var datosEl = wrap.querySelector('[data-pc-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var formato = wrap.dataset.formato;
      var form = wrap.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('[data-pc-anadir]');
      var textoBoton = boton ? boton.querySelector('[data-pc-texto]') : null;
      var error = wrap.querySelector('[data-pc-error]');

      /* Galería */
      var principal = wrap.querySelector('[data-pc-principal]');
      var minis = Array.prototype.slice.call(wrap.querySelectorAll('[data-pc-mini]'));
      var actual = 0;
      function muestra(i) {
        if (!principal || !minis.length) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        principal.style.opacity = '0.2';
        var nueva = new Image();
        nueva.onload = function () {
          principal.src = m.dataset.src; principal.srcset = m.dataset.srcset || '';
          principal.alt = m.dataset.alt || ''; principal.style.opacity = '1';
        };
        nueva.src = m.dataset.src;
        minis.forEach(function (x, j) { x.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
        m.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { muestra(i); }); });
      var izq = wrap.querySelector('[data-pc-ant]'); var der = wrap.querySelector('[data-pc-sig]');
      if (izq) izq.addEventListener('click', function () { muestra(actual - 1); });
      if (der) der.addEventListener('click', function () { muestra(actual + 1); });
      // Deslizar con el dedo en móvil
      if (principal) {
        var x0 = null;
        principal.parentNode.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.parentNode.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) muestra(actual + (dx < 0 ? 1 : -1));
        });
      }

      /* Variantes */
      var opciones = Array.prototype.slice.call(wrap.querySelectorAll('[data-pc-opcion]'));
      function seleccion() {
        return opciones.map(function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function actualiza() {
        var sel = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        opciones.forEach(function (fs, i) {
          var etiqueta = fs.querySelector('[data-pc-valor]');
          if (etiqueta) etiqueta.textContent = sel[i] || '';
        });
        if (!v) {
          if (boton) boton.disabled = true;
          if (textoBoton) textoBoton.textContent = wrap.dataset.txtNodisp;
          return;
        }
        if (inputId) inputId.value = v.id;
        wrap.querySelectorAll('[data-pc-precio]').forEach(function (el) { el.textContent = formatoDinero(v.price, formato); });
        wrap.querySelectorAll('[data-pc-antes]').forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = formatoDinero(v.compare_at_price, formato); el.hidden = false; }
          else el.hidden = true;
        });
        wrap.querySelectorAll('[data-pc-ahorro]').forEach(function (el) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            el.textContent = el.dataset.plantilla.replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100));
            el.hidden = false;
          } else el.hidden = true;
        });
        if (boton) boton.disabled = !v.available;
        var txt = v.available ? wrap.dataset.txtAnadir : wrap.dataset.txtAgotado;
        if (textoBoton) textoBoton.textContent = txt;
        var barraBtn = document.querySelector('[data-pc-barra-btn]');
        if (barraBtn) { barraBtn.disabled = !v.available; barraBtn.textContent = txt; }
        // Imagen de la variante
        if (v.featured_media_id && minis.length) {
          var idx = minis.findIndex(function (m) { return m.dataset.mediaId === String(v.featured_media_id); });
          if (idx > -1 && idx !== actual) muestra(idx);
        }
        if (wrap.dataset.actualizarUrl === 'true' && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      opciones.forEach(function (fs) { fs.addEventListener('change', actualiza); });

      /* Cantidad */
      var cant = wrap.querySelector('[data-pc-cantidad]');
      wrap.querySelectorAll('[data-pc-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(cant.value, 10) || 1) + parseInt(b.dataset.pcCant, 10);
          cant.value = Math.max(1, n);
        });
      });

      /* Añadir al carrito con el cajón del tema */
      if (form) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (!boton || boton.disabled) return;
          if (error) error.textContent = '';
          boton.disabled = true; boton.setAttribute('aria-busy', 'true');
          var cajon = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          var fd = new FormData(form);
          if (cajon && typeof cajon.getSectionsToRender === 'function') {
            fd.append('sections', cajon.getSectionsToRender().map(function (s) { return s.id; }));
            fd.append('sections_url', window.location.pathname);
            if (typeof cajon.setActiveElement === 'function') cajon.setActiveElement(document.activeElement);
          }
          var rutas = window.routes || {};
          fetch((rutas.cart_add_url || '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (error) error.textContent = res.description || res.message || wrap.dataset.txtError;
                return;
              }
              if (cajon && typeof cajon.renderContents === 'function') {
                if (cajon.classList.contains('is-empty')) cajon.classList.remove('is-empty');
                cajon.renderContents(res);
              } else {
                window.location.href = rutas.cart_url || '/cart';
              }
            })
            .catch(function () { if (error) error.textContent = wrap.dataset.txtError; })
            .finally(function () {
              boton.removeAttribute('aria-busy');
              var sel = seleccion();
              var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); }) || variantes[0];
              boton.disabled = v ? !v.available : false;
            });
        });
      }

      /* Barra fija de compra en móvil */
      var barra = document.querySelector('[data-pc-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (es) {
          es.forEach(function (e) { barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        });
        obs.observe(boton);
        var bb = barra.querySelector('[data-pc-barra-btn]');
        if (bb) bb.addEventListener('click', function () {
          if (form && typeof form.requestSubmit === 'function') form.requestSubmit(); else if (boton) boton.click();
        });
      }
    });
  }

  function initTodo(raiz) {
    initMarquesinas(raiz);
    initReveal(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); initParallax(); });
  } else { initTodo(); initParallax(); }

  // Editor de Shopify: re-inicializa al añadir o editar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
